import styled from '@emotion/styled';
import { COLORS } from '../../constants';

const bannerHeight = 58;
const headerHeight = 110;
const footerHeight = 50;

export const StyledLayout = styled.div`
  color: ${COLORS.mainTextColor};
`;

export const StyledContent = styled.div<{ withBanner?: boolean }>`
  min-height: calc(100vh - ${({ withBanner }) => headerHeight + footerHeight + (withBanner ? bannerHeight : 0)}px);
`;
